export default __webpack_public_path__ + "static/media/services-background.a2fdf52b.png";